// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'es6-promise/auto'
import promise from 'es6-promise'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import FastClick from 'fastclick'
import Vant, { Toast } from 'vant'
import 'vant/lib/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI, { Message } from 'element-ui'
import messageBox from './plugins/messageBox'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './assets/font/iconfont.css'
import './assets/css/reset.css'
import 'animate.css'
import './assets/css/main.css'
import request from './assets/js/request'
import getQueryString from './assets/js/url'
import auth from './assets/js/auth'
import yiBanAuth from './assets/js/yiBanAuth'
import isMobile from '@/assets/js/isMobile'

import DrawButton from '@/components/DrawButton'

// import getOpenId from './assets/js/getOpenId'
import monitor from './assets/js/monitor' // 页面数据监控

// 数据埋点全局注册
import userActionSave from './plugins/userActionSave.js' // 用户数据保存
Vue.prototype.$userActionSave = userActionSave

// 移除meta标签
import removeMeta from './assets/js/removeMeta'
// 过滤器
import * as filters from './assets/js/filter'
// import Vconsole from 'vconsole'
Vue.component('DrawButton', DrawButton)
Vue.prototype.getQueryString = getQueryString
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

// 还要兼容 如果philips.analytics.trackConversion 存在，则使用philips.analytics.trackConversion
if (
  !window.philips ||
  !window.philips.analytics ||
  !window.philips.analytics.trackConversion ||
  !window.philips.analytics.trackAjax ||
  !window.philips.analytics.trackNavNena
) {
  window.philips = {
    analytics: {
      trackConversion: (data) => {
        console.log('trackConversion', data)
      },
      trackAjax: (data) => {
        console.log('trackAjax', data)
      },
      trackNavNena: (data) => {
        console.log('trackNavNena', data)
      }
    }
  }
}

promise.polyfill()

Vue.config.productionTip = false
Vue.prototype.$removeMeta = removeMeta
FastClick.attach(document.body)
/* eslint-disable */
FastClick.prototype.needsClick = function (target) {
  // 下面这句
  // 这是jq写法
  // if ($(target).parents('.needsclick').length) return true
  while (target.tagName !== 'BODY') {
    // 放在本地插件库, 请将includes换成indexOf判断
    if (target.className.indexOf('needsclick')) return true
    target = target.parentNode
  }
  switch (target.nodeName.toLowerCase()) {
    // Don't send a synthetic click to disabled inputs (issue #62)
    case 'button':
    case 'select':
    case 'textarea':
      if (target.disabled) {
        return true
      }
      break
    case 'input':
      // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
      // if ((deviceIsIOS && target.type === 'file') || target.disabled) {
      //   return true
      // }
      if ((deviceIsIOS && target.type === 'file') || target.disabled) {
        return true
      }
      break
    case 'label':
    case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
    case 'video':
      return true
  }
  return (/\bneedsclick\b/).test(target.className)
}
FastClick.prototype.focus = function (targetElement) {
  var length
  if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('data')) {
    length = targetElement.value.length
    targetElement.setSelectionRange(length, length)
    targetElement.focus()
  } else {
    targetElement.focus()
  }
}
/* eslint-enable */

Vue.use(Vant)
Vue.use(messageBox)
Vue.use(ElementUI)
NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

request.setConfig({
  // baseUrl: '/gateway',
  baseUrl: '',
  beforeSuccess (res, resolve, reject) {
    if (res.config.url.indexOf('payment/miniApp/weChat/pay') != -1) {
      // 判断是否是支付接口，如果是支付宝，不会返回data，做特殊处理
      resolve(res.data)
    } else {
      // 新增易班状态
      if (res.data.code == '000000' || res.data.status == 'success') {
        resolve(res.data)
      } else if (res.data.code == '2008' || res.data.code == '2300' || res.data.code == '2301' || res.data.code == '031002' || res.data.code == '5008' || res.data.code == '8003') {
        // 2008状态码 --> 该手机号已在其他渠道注册，是否绑定用户名密码
        // 2300状态码 --> 手机号验证码登录，但是手机号并没在数据库中，所以要去完善信息，然后直接登录
        // 2301 密码错误
        // 031002 赠品已送完
        // 5008 优惠券已领完
        // 8003 九宫格抽奖次数用完
        reject(res.data)
      } else if (res.data.code == '-1') {
        if (store.getters.isPC) {
          Message.error({ message: res.data.data ? res.data.data : res.data.message })
        } else {
          if (res.data.data) {
            Toast(res.data.data)
          } else {
            Toast(res.data.message)
          }
        }
        reject(res.data)
      } else {
        if (res.data.message) {
          if (store.getters.isPC) {
            Message.error({ message: res.data.message })
          } else {
            Toast(res.data.message)
          }
        }
        reject(res.data)
      }
    }
  },
  beforeError (_, reject) {
    if (store.getters.isPC) {
      Message.error({ message: '当前网络不稳定,请稍后重试' })
    } else {
      Toast('当前网络不稳定,请稍后重试')
    }
    reject()
  }
})

sessionStorage.setItem('isRequst', '1')

// 修复从官网进商品详情报签名不合法的问题
if(window.location.href.includes('%23')) {
  let currentUrl = window.location.href;
  let newUrl = currentUrl.replace(/%23/g, '#');
  if (newUrl !== currentUrl) {
    window.location.href = newUrl;
  }
}

// var _hmt = _hmt || []
// window._hmt = _hmt;
// (function () {
//   var hm = document.createElement('script')
//   hm.src = 'https://hm.baidu.com/hm.js?5d2361cc458f9678f6c7f552c2b4c1d8'
//   var s = document.getElementsByTagName('script')[0]
//   s.parentNode.insertBefore(hm, s)
// })()

router.beforeEach(async (to, from, next) => {
  // let flag = true
  // if (flag && to.path != '/index') {
  //   next('/index')
  //   return
  // }

  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '飞利浦会员商城'
  }
  // 易班↓
  if (to.path == '/activityKv' || to.path == '/activityShop' || to.path == '/product-detail1' || to.path == '/luckdraw') {
    if (!store.getters.status) {
      if ((!getQueryString('verify_request') && !sessionStorage.getItem('verify_request')) && !store.getters.yiBanUserInfo) {
        yiBanAuth()
      } else {
        if (!sessionStorage.getItem('verify_request')) sessionStorage.setItem('verify_request', getQueryString('verify_request'))
        try {
          if (localStorage.getItem('windowHref')) {
            let windowHref = decodeURIComponent(localStorage.getItem('windowHref'))
            let path
            if (windowHref.indexOf('/activityKv') != -1) {
              path = 'activityKv'
            } else if (windowHref.indexOf('/activityShop') != -1) {
              path = 'activityShop'
            } else if (windowHref.indexOf('/product-detail1') != -1) {
              path = 'product-detail1'
            } else if (windowHref.indexOf('/luckdraw') != -1) {
              path = 'luckdraw'
            }
            localStorage.removeItem('windowHref')
            if (windowHref.split('/#/product-detail1?id=')[1]) {
              next({
                path: `/${path}`,
                query: {
                  id: windowHref.split('/#/product-detail1?id=')[1]
                }
              })
            } else {
              next({
                path: `/${path}`,
                query: {}
              })
            }
          }
        } catch (error) { }
        if (sessionStorage.getItem('verify_request')) {
          if (isMobile()) {
            localStorage.setItem('isForm', 1) // 1易班0正常来源
          }
        }
        next()
      }
    } else {
      next()
    }
  } else
  // 易班↑

  // if (to.path != '/login') {
  if (!Object.keys(store.getters.info).includes('id')) {
    if (localStorage.getItem('token')) {
      request(`/gateway/users/users/member/getLoginMessage`, 'get').then(res => {
        if (res.data) {
          store.commit('SET_INFO', res.data)
          store.commit('SET_STATUS', true)
        } else {
          store.commit('SET_INFO', {})
          store.commit('SET_STATUS', false)
          localStorage.clear()
          if (to.meta && to.meta.requireLogin) {
            next('/login')
          } else {
            next()
          }
        }
        if (to.path == '/login') {
          // 如果有登录信息，用户在进入到登录页时直接跳转首页
          next('/index')
        } else {
          next()
        }
      }).catch(() => {
        localStorage.clear()
        next('/login')
      })
    } else {
      if (to.meta && to.meta.requireLogin) {
        next('/login')
      } else {
        next()
      }
    }
  } else {
    if (to.path == '/login') {
      // 如果有登录信息，用户在进入到登录页时直接跳转首页
      next('/index')
    } else {
      next()
    }
  }
  // } else {
  //   next()
  // }
  if (to.name != 'product-detail' && to.path != '/activityKv' && to.path != '/activityShop' && to.path != '/product-detail1' && to.path != '/luckdraw') {
    // 因为详情页面需要传一个商品名称，所以不在路由里调用，改为详情获取到商品名称之后再调
    monitor({
      pageId: to.meta.pageId, // 页面id
      currencyId: null, // 活动的id
      currencyName: null, // 活动名称
      pageTypeId: null // 页面类型id
    })
  }
  // NProgress.start()
})

router.afterEach(() => {
  // document.body.scrollTop = 0
  // document.documentElement.scrollTop = 0
  // 在即将进入新的页面组件前，关闭掉进度条
  // NProgress.done()
})

// 如果是微信内置浏览器
let ua = navigator.userAgent.toLowerCase()
if (ua.indexOf('micromessenger') != -1) {
  // 授权返回code
  // if (getQueryString('code') && !sessionStorage.getItem('openid')) {
  //   sessionStorage.setItem('code', getQueryString('code'))
  //   getOpenId(sessionStorage.getItem('code'))
  // } else if (!sessionStorage.getItem('code') && !sessionStorage.getItem('openid')) {
  //   auth()
  // }
  // 授权返回openid
  if (sessionStorage.getItem('openid')) {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  } else {
    if (getQueryString('openid')) {
      sessionStorage.setItem('openid', getQueryString('openid'))
      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        router,
        store,
        components: { App },
        template: '<App/>'
      })
    } else {
      auth()
    }
  }
} else {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js